import { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { fetchCampaignTable } from 'features/dashboard/table/campaign/campaignTableSlice'
import CampaignTableHeader from 'features/dashboard/table/campaign/CampaignTableHeader'
import DashboardTable from 'features/dashboard/table/DashboardTable'
import { DashboardTypes } from 'features/Codes'
import useDebounce from 'utils/hooks/useDebounce'
import useDefaultSort from 'features/dashboard/table/column/useDefaultSort'

const CampaignTable = () => {
  const dispatch = useDispatch()
  const {
    common: { from, to },
    filter: { filters },
    table: {
      config: {
        columns: { [DashboardTypes.CAMPAIGN]: columns },
      },
      campaignTable: { page, sort },
    },
  } = useSelector(state => state.dashboard, shallowEqual)
  const debouncedColumns = useDebounce(columns, 500)
  useDefaultSort(debouncedColumns)

  useEffect(() => {
    const { abort } = dispatch(fetchCampaignTable())
    return () => abort()
  }, [dispatch, from, to, page, sort, filters, debouncedColumns])

  return (
    <div className="set_table">
      <h4 className="screen_out"> 캠페인 탭 내용 </h4>
      <CampaignTableHeader />
      <DashboardTable />
    </div>
  )
}
export default CampaignTable
